import IconBolt from '@/components/_icons/IconBolt.svg'
import IconDot from '@/components/_icons/IconDot.svg'

const ICONS = {
  bolt: { component: IconBolt, class: 'bolt' },
  dot: { component: IconDot, class: 'dot' },
}

export const BADGES = {
  bestseller: { type: 'bestseller', translationKey: 'bestseller' },
  discount50: {
    type: 'discount-50',
    translationKey: 'discount',
    translationVar: 50,
    icon: ICONS.bolt,
  },
  discount40: {
    type: 'discount-40',
    translationKey: 'discount',
    translationVar: 40,
    icon: ICONS.bolt,
  },
  discount30: {
    type: 'discount-30',
    translationKey: 'discount',
    translationVar: 30,
    icon: ICONS.bolt,
  },
  discount20: {
    type: 'discount-20',
    translationKey: 'discount',
    translationVar: 20,
    icon: ICONS.bolt,
  },
  exclusive: { type: 'exclusive', translationKey: 'exclusive' },
  lastChance: { type: 'last-chance', translationKey: 'last_chance' },
  limited: { type: 'limited', translationKey: 'limited' },
  new: { type: 'new', translationKey: 'new', icon: ICONS.bolt },
  newColor: { type: 'new-color', translationKey: 'new_color', icon: ICONS.dot },
  newColors: { type: 'new-colors', translationKey: 'new_colors' },
  newGeneration: { type: 'new-generation', translationKey: 'new_generation' },
  sellingFast: { type: 'selling-fast', translationKey: 'selling_fast' },
  soldOut: { type: 'sold-out', translationKey: 'sold_out' },
  waterproof: { type: 'waterproof', translationKey: 'waterproof' },
}

export const BADGE_BACKGROUND_COLORS = {
  white: 'white',
  grey: 'grey',
  lightgrey: 'lightgrey',
  blue: 'blue',
}

export const BADGE_SIZES = {
  small: 'small',
  normal: 'normal',
}
